export const scannerConfig = {
    constraints: {
        video: {
            width: window.innerWidth,
        },
    },
    canvasStyles: [
        {
            lineWidth: 1,
            fillStyle: '#00950685',
            strokeStyle: '#00950685',
        },
        {
            font: '17px serif',
            fillStyle: '#ff0000',
            strokeStyle: '#ff0000',
        },
    ],
};

export const responsiveOptions = [
    {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3,
    },
    {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2,
    },
    {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
    },
];